export const METADATA_KEY_GUMLET = 'gumletImageQueries';
